import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import UpdateCustomerModal from "../CustomersMainPage/UpdateCustomerModal.js";
import api from "../../services/api.js";
import AddStickyNote from "./AddStickyNote.js";

const CustomerProfileView = ({ role, cust_id, token }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const [openEdit, setOpenEdit] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [openAddNote, setOpenAddNote] = useState(false);

  const fetchCustomer = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/customer/${cust_id}`, {
        headers: { Authorization: token },
      });

      setCustomer(res.data?.data || null);
    } catch (err) {
      console.error("Error fetching customer:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomer();
  }, [cust_id, token]);

  if (loading)
    return (
      <p className="text-gray-500 dark:text-gray-400">Loading profile...</p>
    );

  if (!customer)
    return (
      <p className="text-red-500 dark:text-red-300">Customer not found.</p>
    );

  const formatDate = (dateString) => {
    if (!dateString) return "-";

    return new Date(dateString).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const fields = [
    ["Full Name", customer.full_name],
    ["ID Pelanggan", customer.customer_id],
    ["Email", customer.email],
    ["Phone Number", customer.phone_number],
    ["Residence Type", customer.residence_type],
    ["Address", customer.address],
    ["City", customer.city],
    ["State", customer.state],
    ["Identity Type", customer.identity_type],
    ["Identity Number", customer.identity_number],
    ["Referred by", customer.customer_group],
    ["Status", customer.status],
    ["Registration at", formatDate(customer.created_at)],
  ];

  const handleEdit = (customer) => {
    setSelectedCustomer(customer);
    setOpenEdit(true);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-xl border border-gray-200 dark:border-gray-700">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <div className="p-3 bg-blue-100 dark:bg-blue-900 rounded-xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-blue-600 dark:text-blue-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
              />
            </svg>
          </div>

          <h2 className="text-2xl font-bold dark:text-white">
            Customer Profile
          </h2>
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {fields.map(([label, value], index) => (
            <div
              key={index}
              className="p-4 bg-gray-50 dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 hover:shadow-md transition-all"
            >
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {label}
              </p>
              <p className="text-lg font-semibold text-gray-900 dark:text-white mt-1">
                {value || "-"}
              </p>
            </div>
          ))}
        </div>

        {role === "billing" && (
          <button
            onClick={() => handleEdit(customer)}
            className="
      m-10 ml-auto
      inline-flex items-center justify-center
      px-5 py-2.5
      text-sm font-semibold tracking-wide
      rounded-xl
      bg-blue-600 text-white
      hover:bg-blue-700
      active:scale-[0.98]
      transition-all duration-200 ease-out
      focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
      focus:ring-offset-white dark:focus:ring-offset-gray-900
      disabled:bg-blue-400
      disabled:cursor-not-allowed
      disabled:opacity-60
    "
          >
            Update Profile
          </button>
        )}

        <button
          onClick={() => setOpenAddNote(true)}
          className="
  m-10 ml-auto
  inline-flex items-center justify-center
  px-5 py-2.5
  text-sm font-semibold tracking-wide
  rounded-xl
  bg-yellow-400 text-gray-900
  hover:bg-yellow-500
  active:scale-[0.98]
  transition-all duration-200 ease-out
  focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2
  focus:ring-offset-white dark:focus:ring-offset-gray-900
  disabled:bg-yellow-300
  disabled:cursor-not-allowed
  disabled:opacity-60
"
        >
          Add Sticky Notes
        </button>

        <UpdateCustomerModal
          open={openEdit}
          onClose={() => setOpenEdit(false)}
          token={token}
          customer={selectedCustomer}
          onSuccess={fetchCustomer}
        />
        <AddStickyNote
          open={openAddNote}
          onClose={() => setOpenAddNote(false)}
          userId={cust_id}
          adminId={99}
          token={token}
          onSuccess={() => window.location.reload()} // atau push state
        />
      </div>
    </motion.div>
  );
};

export default CustomerProfileView;
